<template>
    <div component="ContractTemplate" template="page">
        <div class="bg">
            <v-card class="holder">
                <v-snackbar class="text-center" centered v-model="showStatus" timeout="1900">
                    <h3 class="success text-center" v-if="status">Template was saved.</h3>
                    <h3 class="error text-center" v-else>There was error saving template.</h3>
                </v-snackbar>

                <div class="header">
                    <div>Contract template</div>

                    <div class="buttons">
                        <a class="button camera" color="base" @click="saveTemplate">
                            <i class="icon">save</i>
                            <span>SAVE</span>
                        </a>

                        <a class="button" radius="circle" @click="goToContract">
                            <i class="icon">close</i>
                        </a>
                    </div>
                </div>

                <ckeditor v-model="template" :config="editorConfig" class="editor"></ckeditor>
            </v-card>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'ContractTemplate',

    data() {
        return {
            editorConfig: {
                extraAllowedContent: '*[*]{*}(*)',
                entities: false,
                basicEntities: false,
                forceSimpleAmpersand: true,
                height: '100%',
            },
            templateBackup: null,
            showStatus: false,
            status: false,
        };
    },

    async mounted() {
        await this.loadCurrentContractTemplate();
        this.templateBackup = this.getContractTemplate;
    },

    methods: {
        ...mapMutations(['setContractTemplate']),
        ...mapActions(['loadCurrentContractTemplate', 'storeContractTemplate']),

        async saveTemplate() {
            try {
                await this.storeContractTemplate();
                this.status = true;
            } catch (e) {
                this.status = false;
                throw e;
            } finally {
                this.showStatus = true;
            }
        },

        goToContract() {
            this.$router.go(-1);
            //            this.$router.push({ path: '/contract' }).catch(() => {});
        },
    },

    computed: {
        ...mapGetters(['getContractTemplate']),

        template: {
            get() {
                return this.getContractTemplate;
            },
            set(val) {
                this.setContractTemplate(val);
            },
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ContractTemplate'] {
    height: 100vh;
    max-height: 100vh;

    .holder {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px 20px 10px;
        .radiusBig !important;
    }

    .header {
        margin-bottom: 4rem;
        align-items: center;
        display: flex;

        .buttons {
            margin-left: auto;
        }
    }
}

.editor {
    display: flex;
    flex: 1;
}

/deep/.cke_chrome {
    flex: 1;
    display: flex;
    flex-direction: column;

    .cke_inner.cke_reset {
        flex: 1;
        min-height: 800px;
        display: flex;
        flex-direction: column;

        #cke_1_contents {
            min-height: 800px;
            flex: 1 !important;
        }
    }
}
</style>
